import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { InputText } from 'primereact/inputtext'
import apiService from '../../services/api.service'

const DADOS_COMPLEMENTARES_PATH = '/lottustech/dadoscomplementares'

/**
 * Campos complementares configurados para o tipo ('pessoaFisica', 'pessoaJuridica') na unidade logada, com a
 * empresa como fallback. Sem tipo nao busca. Config ausente ou falha na busca devolvem {}: quem usa esconde a
 * aba, e o cadastro segue funcionando.
 */
export function useCamposComplementares(tipo) {
  const [campos, setCampos] = useState({})

  useEffect(() => {
    if (!tipo) {
      return undefined
    }
    let ativo = true
    apiService
      .get(`${DADOS_COMPLEMENTARES_PATH}/${tipo}`)
      .then((response) => {
        const data = _.get(response, 'data')
        if (ativo) {
          setCampos(_.isPlainObject(data) ? data : {})
        }
      })
      .catch(() => {
        if (ativo) {
          setCampos({})
        }
      })
    return () => {
      ativo = false
    }
  }, [tipo])

  return campos
}

export default function LtsCamposComplementares(props) {
  const onChange = (campo, event) => {
    const dadosComplementares = _.cloneDeep(_.get(props.record, `dadosComplementares`, {}))
    dadosComplementares[campo] = event.target.value
    props.setField(dadosComplementares)
  }

  const resolveValue = (nomeCampo) => {
    let value = _.get(props.record, `dadosComplementares.${nomeCampo}`)
    if (_.isEmpty(value)) {
      value = props.camposComplementares[nomeCampo].default || null
    }
    return value
  }

  return (
    <React.Fragment>
      <div className="p-grid form-group">
        {Object.keys(props.camposComplementares).map((nomeCampo) => (
          <div key={nomeCampo} className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
            <span className="p-float-label">
              <InputText
                value={resolveValue(nomeCampo)}
                onChange={(e) => onChange(nomeCampo, e)}
                name={nomeCampo}
                className={'width-25-rem'}
              />
              <label>{props.camposComplementares[nomeCampo].label}</label>
            </span>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}
